export var styles = {
    base: {
        backgroundColor: 'var(--delta)',
        borderColor: 'var(--mezo)!important',
        borderRadius: '.5rem',
        borderStyle: 'solid!important',
        borderWidth: '1px!important',
        color: 'var(--penta)',
        fontSize: '16px',
        fontWeight: '500',
        height: '46px',
        width: '100%',
    },
    placeholder: {
        color: '#cacadb',
        fontWeight: '400',
        lineHeight: '1.5',
        fontSize: '16px',
        padding: '0px',
    },
};
